module.exports = __webpack_public_path__ + "img/icn_facebook.51224f10.svg";